import React, { useEffect, useState } from 'react';
import { BarChart } from '../../../common/ReusableComponent/Chart';

const GasRevenueChart = ({ total_amount_of_all_invoices = [] }) => {
  const currentYear = new Date().getFullYear();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!total_amount_of_all_invoices || total_amount_of_all_invoices.length === 0) return;

    // Aggregate monthly revenue
    const aggregated = total_amount_of_all_invoices.reduce((acc, curr) => {
      acc[curr.month] = (acc[curr.month] || 0) + curr.total; // Use curr.total
      return acc;
    }, {});

    const sortedMonths = Object.keys(aggregated).sort();

    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ];

    const labels = sortedMonths.map(monthKey => {
      const [, month] = monthKey.split('-');
      return monthNames[parseInt(month, 10) - 1];
    });

    const revenue = sortedMonths.map(month => aggregated[month]);

    setChartData({
      labels,
      datasets: [
        {
          label: `Total Revenue (${currentYear})`,
          data: revenue,
          backgroundColor: '#4A90E2',
          borderRadius: 6,
          borderSkipped: false,
        },
      ],
    });
  }, [total_amount_of_all_invoices]);

  return (
    chartData ? (
      <div className="chart-area">
        <BarChart
          labels={chartData.labels}
          datasets={chartData.datasets}
          title={`Monthly Gas Revenue - ${currentYear}`}
          noBorder
          noShadow
          padding={false}
          width="600px"
          height="265px"
          options={{
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: (context) => `\u20b9 ${context.parsed.y.toLocaleString()}`
                }
              }
            },
            scales: {
              y: {
                ticks: {
                  callback: (val) => `\u20b9${val}`,
                }
              }
            }
          }}
        />
      </div>
    ) : (
      <div className="no-data-message">No data available</div>
    )
  );
};

export default GasRevenueChart;
